function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './WidgetCurrencyConverter.css';
import React from 'react';
import { get, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import FormField from './components/FormField';
import SelectField from './components/SelectField';
import { useHistory, useLocation } from 'react-router-dom';
import addQueryString from '../Listing';
import useMobile from './useMobile';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { runValidations, validateRequired } from './commomFunctions';
const WidgetCurrencyConverter = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const apiURL = typeof window !== 'undefined' ? window.location.origin : get(sitecoreContext, 'origin') || 'https://vdqa.testvisitdubai.com';

  // get(sitecoreContext, 'origin') || 'https://vdqa.testvisitdubai.com';
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const variables = BackgroundColorHex ? {
    "--m84-primary-color": BackgroundColorHex,
    "--m84-primary-active-color": ActiveColorHex,
    "--m84-color": ColorHex
  } : {
    "--m84-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m84-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m84-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const mainTitle = get(fields, 'data.datasource.title.jss.value');
  const otherCurrenciesTitle = get(fields, 'data.datasource.otherCurrenciesTitle.jss.value');
  const currencyTextTitle = get(fields, 'data.datasource.currencyText.jss.value');
  const convertCurrency = get(fields, 'data.datasource.convertCurrency.currency');
  const convertCurrencyTitle = get(convertCurrency, 'title.jss.value');
  const convertCurrencyIcon = get(convertCurrency, 'icon.jss.value.src');
  const convertCurrencyId = get(convertCurrency, 'currencyId.jss.value');
  const mainCurrenciesArray = get(fields, 'data.datasource.mainCurrencies.currencies');
  const otherConvertCurrenciesArray = get(fields, 'data.datasource.otherConvertCurrencies.currencies');
  const tableTitle = get(fields, 'data.datasource.tableTitle.jss.value');
  const tableText = get(fields, 'data.datasource.tableText.jss.value');
  const [analytics] = get(fields, 'data.analytics.parameters', [{}]);
  const tableRows = get(fields, 'data.datasource.tableRows');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const isMobile = useMobile();
  const location = useLocation();
  const [disableSubmit, setDisableSubmit] = React.useState(false);
  const [formResponseError, setFormResponseError] = React.useState('');
  let allErrors = [];
  let history = useHistory();
  const [inputValue, setInputValue] = React.useState({
    mainCurrencyValue: '1',
    convertedCurrencyValue: '0'
  });
  const {
    mainCurrencyValue,
    convertedCurrencyValue
  } = inputValue;
  const [isAllRatesLoaded, setIsAllRatesLoaded] = React.useState(false);
  const [otherCurrenciesValueState, setOtherCurrenciesValueState] = React.useState([]);
  const [preselectedValue, setPreselectedValue] = React.useState({});
  const [isMobileView, setIsMobileView] = React.useState(false);
  const [allowRender, setAllowRender] = React.useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setInputValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [name]: value
    }));
  };
  const clearInput = () => {
    setInputValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
      mainCurrencyValue: ''
    }));
  };
  const calculateRate = (rate, key) => {
    const mainValue = inputValue.mainCurrencyValue;
    const res = Number(mainValue) * rate;
    if (rate) {
      setInputValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [key]: `${res.toFixed(2)}`
      }));
    }
  };
  React.useEffect(() => {
    if (mainCurrencyValue && Object.keys(preselectedValue).length !== 0) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [mainCurrencyValue, preselectedValue]);
  React.useEffect(() => {
    setIsMobileView(isMobile);
  }, [isMobile]);
  React.useEffect(() => {
    let countryCode = '';
    const queryParams = qsToObject(location.search);
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(item => item.indexOf('user_country_code') > -1);
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
    }
    if (process.env.STORYBOOK_MODE) {
      countryCode = 'PK';
    }
    fetch(`${apiURL}/api/currencyapi/getallcountries`).then(response => {
      if (response && response.status === 200) {
        return response.json();
      }
    }).then(response => {
      const defaultId = 'US';
      const codeForFiltering = countryCode ? countryCode : defaultId;
      const currentCountryItem = response.find(item => item.id === codeForFiltering);
      const serverCountry = mainCurrenciesArray.find(item => item.currencyId.jss.value === currentCountryItem.currencyId);
      if (countryCode === 'AE' || serverCountry === undefined) {
        setPreselectedValue({});
        setDisableSubmit(true);
      } else {
        setPreselectedValue(serverCountry);
      }
      mainCurrenciesArray.map(el => {
        el['label'] = el.title.jss.value;
        el['value'] = el.currencyId.jss.value;
      });
      const otherCurrenciesToState = [];
      otherConvertCurrenciesArray.forEach(el => {
        otherCurrenciesToState.push({
          id: `${serverCountry ? serverCountry.value : ''}_${el.currencyId.jss.value}`,
          currencyId: el.currencyId.jss.value,
          value: '0',
          loading: false,
          src: Object.keys(el.icon).length ? el.icon.jss.value.src : '',
          title: el.title.jss.value
        });
      });
      setOtherCurrenciesValueState(otherCurrenciesToState);
    }).then(() => setAllowRender(true)).catch(e => {
      console.error(e);
    });
  }, []);
  const [errorMainCurrency, setErrorMainCurrency] = React.useState('');
  const mainCurrencyFieldProps = {
    value: mainCurrencyValue,
    label: mapDictionary.get('amount'),
    fieldError: errorMainCurrency,
    setError: setErrorMainCurrency,
    type: 'number',
    id: convertCurrencyId,
    name: 'mainCurrencyValue',
    placeholder: '',
    labelLight: false,
    required: false,
    errorValue: 'validateRequired',
    changeEvent: event => {
      handleChange(event);
    },
    blurEvent: value => {
      mainCurrencyFieldProps.validate(value);
    },
    focusEvent: value => {
      clearInput();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mainCurrencyValue;
      return runValidations([validateRequired], value, mainCurrencyFieldProps);
    }
  };
  allErrors.push(mainCurrencyFieldProps);
  const mainCurrencySelectFieldProps = {
    value: Object.keys(preselectedValue).length ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, Object.keys(preselectedValue.icon.jss.value).length ? /*#__PURE__*/React.createElement("img", {
        alt: preselectedValue.icon.jss.value.alt,
        className: `select-item__image ${Object.keys(preselectedValue.icon.jss.value).length ? '' : 'hidden'}`,
        src: preselectedValue.icon.jss.value.src
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, preselectedValue.title.jss.value)),
      title: isMobileView ? preselectedValue.currencyId.jss.value : preselectedValue.title.jss.value,
      value: preselectedValue.title.jss.value
    } : {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      })),
      title: '',
      value: ''
    },
    label: mapDictionary.get('currency'),
    id: 'main-currency-select',
    name: 'main-currency',
    labelLight: false,
    autoComplete: 'main-currency',
    required: false,
    changeEvent: obj => {
      setPreselectedValue(obj);
      if (otherCurrenciesValueState.length) {
        const copy = [...otherCurrenciesValueState];
        copy.forEach(el => {
          el.id = `${obj.value}_${el.currencyId}`;
        });
        setOtherCurrenciesValueState(copy);
      }
    },
    blurEvent: value => {},
    options: mainCurrenciesArray
  };

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    for (const fieldObj of allErrors) {
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };
  const onSubmit = e => {
    e.preventDefault();
    setFormResponseError('');
    if (validateAllFields()) {
      const preselectedValueTitle = get(preselectedValue, 'title.jss.value');
      tealiumClickFunc(tealiumMergeClickData(analytics, params), [preselectedValueTitle, convertCurrencyTitle]);
      const mainCurrencyId = preselectedValue.value;
      const convertCurrencyId = convertCurrency.currencyId.jss.value;
      const mainValue = inputValue.mainCurrencyValue;
      let inputValueCopied = [...otherCurrenciesValueState];
      const requestQueries = [`${convertCurrencyId}`];
      let requestCount = Math.round(inputValueCopied.length / 2);
      for (let i = 0; i < requestCount; i++) {
        let step = 2;
        let index = i * step;
        let nextIndex = index + 1;
        let firstVal;
        let secondVal;
        if (inputValueCopied[index]) {
          firstVal = inputValueCopied[index].currencyId;
        }
        if (inputValueCopied[nextIndex]) {
          secondVal = inputValueCopied[nextIndex].currencyId;
        }
        const requestQuery = nextIndex !== inputValueCopied.length ? `${firstVal},${secondVal}` : `${firstVal}`;
        requestQueries.push(requestQuery);
      }
      Promise.all(requestQueries.map(query => fetch(`${apiURL}/api/currencyapi/exchangerates?from=${mainCurrencyId}&to=${query}`))).then(function (responses) {
        setDisableSubmit(true);
        return Promise.all(responses.map(function (response) {
          if (response && response.status === 200) {
            addQueryString('from', mainCurrencyId, history);
            addQueryString('to', convertCurrencyId, history);
            return response.json();
          } else {
            setFormResponseError(`api error ${response.status}`);
          }
        }));
      }).then(function (data) {
        setDisableSubmit(false);
        data.forEach((rate, index) => {
          if (Object.keys(rate).length === 1 && Object.keys(rate)[0] === `${mainCurrencyId}_${convertCurrencyId}`) {
            calculateRate(rate[`${mainCurrencyId}_${convertCurrencyId}`].val, 'convertedCurrencyValue');
          } else {
            Object.keys(rate).forEach(key => {
              const calculateRate = Number(mainValue) * rate[`${key}`].val;
              let objIndex = inputValueCopied.findIndex(item => item.id === key);
              if (objIndex !== -1) {
                inputValueCopied[objIndex].value = calculateRate.toFixed(2);
                inputValueCopied[objIndex].loading = false;
              }
            });
            setOtherCurrenciesValueState(() => inputValueCopied);
          }
        });
      }).then(function (response) {
        if (Object.values(inputValueCopied).map(el => el.loading).filter(item => item === true).length === 0) {
          setIsAllRatesLoaded(true);
        }
        inputValueCopied.forEach(el => {
          el['loading'] = true;
        });
        setIsAllRatesLoaded(false);
      }).catch(function (error) {
        console.log(error);
      });
    }
  };
  if (!fields) {
    console.warn('WidgetCurrencyConverter component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[WidgetCurrencyConverter component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-10 currency-widget-centered",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title2"
  }, mainTitle), allowRender ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    className: "currency-widget__main-form",
    onSubmit: event => onSubmit(event)
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement(FormField, mainCurrencyFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement(SelectField, mainCurrencySelectFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: " body-small form-label"
  }, mapDictionary.get('convertedAmount')), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__display-field"
  }, " ", convertedCurrencyValue)), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: " body-small form-label"
  }, mapDictionary.get('currency')), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-flag"
  }, convertCurrencyIcon && /*#__PURE__*/React.createElement("img", {
    className: "currency-widget__icon",
    src: convertCurrencyIcon,
    alt: convertCurrencyTitle
  }), /*#__PURE__*/React.createElement("span", null, isMobileView ? convertCurrencyId : convertCurrencyTitle)))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: disableSubmit,
    className: "btn btn-primary venue-shortlist__req-submit"
  }, mapDictionary.get('convert'))), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null, /*#__PURE__*/React.createElement("form", {
    action: "",
    className: "currency-widget__additional-form"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title4"
  }, otherCurrenciesTitle), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__columns"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__additional-form-left"
  }, otherCurrenciesValueState.map(item => {
    const objIndex = otherCurrenciesValueState.findIndex(el => el.id === item.id);
    const defaultVal = otherCurrenciesValueState.length && otherCurrenciesValueState[objIndex].value;
    return /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__column-field",
      key: `value_${item.id}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__display-field"
    }, isAllRatesLoaded ? item.value : defaultVal));
  })), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__additional-form-right"
  }, otherConvertCurrenciesArray.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__column-field",
      key: `flag_${item.title.jss.value}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__form-field-flag"
    }, Object.keys(item.icon.jss.value).length ? /*#__PURE__*/React.createElement("img", {
      className: "currency-widget__icon",
      src: item.icon.jss.value.src,
      alt: item.icon.jss.value.src
    }) : null, /*#__PURE__*/React.createElement("span", null, isMobileView ? item.currencyId.jss.value : item.title.jss.value)));
  })))), /*#__PURE__*/React.createElement("p", {
    className: "currency-widget__form-notification"
  }, currencyTextTitle), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__table-header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title3"
  }, tableTitle), /*#__PURE__*/React.createElement("p", {
    className: "currency-widget__form-notification"
  }, tableText)), /*#__PURE__*/React.createElement("table", {
    className: "currency-widget__table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableItem'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('guidePrice')), /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableFirstCurrencyFull'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('tableFirstCurrencyShort')), /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableSecondCurrencyFull'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('tableSecondCurrencyShort')))), /*#__PURE__*/React.createElement("tbody", null, tableRows.map(rowData => /*#__PURE__*/React.createElement("tr", {
    key: rowData.title.jss.value
  }, /*#__PURE__*/React.createElement("td", null, rowData.title.jss.value), /*#__PURE__*/React.createElement("td", null, rowData.firstPrice.jss.value), /*#__PURE__*/React.createElement("td", null, rowData.secondPrice.jss.value)))))) : null)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1m2tsl5";
const ltrStyles = "lh09v06";
const rtlStyles = "r1k79m0m";
export default WidgetCurrencyConverter;